import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  btnsBox,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  inputOutlined,
  paperProps,
} from 'app/components/SaveTemplate/SaveTemplate.sx';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, InputAdornment, OutlinedInput, Typography } from '@mui/material';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import CustomSwitch from 'app/components/CustomSwitch';
import CustomInput from 'app/components/CustomInput';
import CustomSelect from 'app/components/CustomSelect';
import useSaveTemplate from 'app/components/SaveTemplate/useSaveTemplate';
import CalendarIcon from 'app/components/Icons/CalendarIcon';
import DatePicker from 'react-datepicker';
import { closeBtn } from 'app/components/Filter/Filter.sx';
import SuccessModal from 'app/components/SuccessModal';
import logger from 'app/utils/logger';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  save?: any;
  changeName?: any;
  successModal?: any;
  setSuccessModal?: any;
  pathUrl?: any;
  templateName?: string;
  dataCreateTemplate?: any;
  error?: boolean;
  setError?: any;
}

const SaveTemplate = (props: Props) => {
  // const {
  //   showDates,
  //   setShowDates,
  //   options,
  //   firstFocused,
  //   onFocusNext,
  //   onFocusEnd,
  //   handlerBlur,
  //   resNextDate,
  //   nextDate,
  //   handlerNextDate,
  //   secondFocused,
  //   handlerEndDate,
  //   endDate,
  //   resEndDate,
  //   // successModal,
  //   // setSuccessModal,
  // } = useSaveTemplate();
  const {
    open,
    close,
    save,
    changeName,
    successModal,
    setSuccessModal,
    pathUrl,
    templateName,
    dataCreateTemplate,
    error,
    setError,
  } = props;
  // const [error, setError] = useState(false);

  // useEffect(() => {
  //   setError(false);
  // }, [templateName]);
  //
  // useEffect(() => {
  //   setError(false);
  //   changeName('');
  // }, [open]);
  //
  // useEffect(() => {
  //   if (dataCreateTemplate?.result === 'error') {
  //     setError(true);
  //   }
  //   if (dataCreateTemplate?.result === 'accepted') {
  //     close(false);
  //   }
  // }, [dataCreateTemplate]);

  useEffect(() => {
    if (successModal) {
      changeName('');
      setError(false);
    }
  }, [successModal]);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={dialogTitle}>
          <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>Şablon kimi yadda saxla</Typography>
          {/*<Button*/}
          {/*  color={'tertiary'}*/}
          {/*  onClick={() => {*/}
          {/*    close(false);*/}
          {/*  }}*/}
          {/*  sx={closeBtn}*/}
          {/*>*/}
          {/*  <CloseIcon />*/}
          {/*</Button>*/}
        </DialogTitle>
        <DialogContent sx={dialogContent}>
          <Box sx={dialogContentBoxes}>
            <CustomInput
              title={'Şablonun adı'}
              placeholder={'Şablonun adı'}
              handleChange={(e: any) => {
                changeName(e.target.value);
                setError(false);
              }}
              rest={{ maxLength: 60 }}
              value={templateName}
              isValid={error}
              errorText={'Qeyd edilən ad ilə şablon artıq mövcuddur'}
            />
          </Box>
          {/*<CustomSwitch*/}
          {/*  sx={{ paddingLeft: '12px', height: '48px' }}*/}
          {/*  title={'Dövri ödəniş'}*/}
          {/*  checked={showDates}*/}
          {/*  handleToggle={setShowDates}*/}
          {/*/>*/}
          {/*{showDates && (*/}
          {/*  <>*/}
          {/*    <CustomSelect*/}
          {/*      options={options}*/}
          {/*      title={'Avtomatik ödəmə periodu'}*/}
          {/*      placeholder={'Avtomatik ödəmə periodu'}*/}
          {/*    />*/}
          {/*    <CustomInput title={'Ödəniş günü'} placeholder={'Ödəniş günü'} />*/}
          {/*    <Box sx={dialogContentBoxes}>*/}
          {/*      <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>Növbəti ödəniş tarixi</Typography>*/}
          {/*      <OutlinedInput*/}
          {/*        inputProps={{ style: { paddingLeft: '12px' } }}*/}
          {/*        value={resNextDate}*/}
          {/*        onFocus={onFocusNext}*/}
          {/*        placeholder={'Tarix aralığını seçin'}*/}
          {/*        sx={inputOutlined}*/}
          {/*        startAdornment={*/}
          {/*          <InputAdornment sx={{ margin: '0px' }} position={'start'}>*/}
          {/*            <CalendarIcon sx={{ fill: 'transparent' }} />*/}
          {/*          </InputAdornment>*/}
          {/*        }*/}
          {/*      />*/}
          {/*    </Box>*/}
          {/*    {firstFocused && (*/}
          {/*      <Box sx={{ position: 'fixed', zIndex: 1, marginTop: '510px' }}>*/}
          {/*        <DatePicker*/}
          {/*          selected={nextDate}*/}
          {/*          onChange={(date) => {*/}
          {/*            handlerNextDate(date);*/}
          {/*          }}*/}
          {/*          inline*/}
          {/*          shouldCloseOnSelect={true}*/}
          {/*          onClickOutside={handlerBlur}*/}
          {/*        />*/}
          {/*      </Box>*/}
          {/*    )}*/}
          {/*    <Box sx={dialogContentBoxes}>*/}
          {/*      <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>Növbəti ödəniş tarixi</Typography>*/}
          {/*      <OutlinedInput*/}
          {/*        inputProps={{ style: { paddingLeft: '12px' } }}*/}
          {/*        value={resEndDate}*/}
          {/*        onFocus={onFocusEnd}*/}
          {/*        placeholder={'Tarix aralığını seçin'}*/}
          {/*        sx={inputOutlined}*/}
          {/*        startAdornment={*/}
          {/*          <InputAdornment sx={{ margin: '0px' }} position={'start'}>*/}
          {/*            <CalendarIcon sx={{ fill: 'transparent' }} />*/}
          {/*          </InputAdornment>*/}
          {/*        }*/}
          {/*      />*/}
          {/*    </Box>*/}
          {/*    {secondFocused && (*/}
          {/*      <Box sx={{ position: 'fixed', zIndex: 1, marginTop: '700px' }}>*/}
          {/*        <DatePicker*/}
          {/*          selected={endDate}*/}
          {/*          onChange={(date) => {*/}
          {/*            handlerEndDate(date);*/}
          {/*          }}*/}
          {/*          inline*/}
          {/*          shouldCloseOnSelect={true}*/}
          {/*          onClickOutside={handlerBlur}*/}
          {/*        />*/}
          {/*      </Box>*/}
          {/*    )}*/}
          {/*  </>*/}
          {/*)}*/}
          <Box sx={btnsBox}>
            <Button
              onClick={() => {
                // close(false);
                save();
              }}
              disabled={templateName?.length === 0}
            >
              Yadda saxla
            </Button>
            <Button
              color={'tertiary'}
              sx={{ display: 'flex', gap: '12px', '& .MuiSvgIcon-root': { width: '22px', height: '22px' } }}
              onClick={() => {
                close(false);
                setError(false);
                changeName('');
              }}
            >
              İmtina
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <SuccessModal
        open={successModal}
        close={setSuccessModal}
        closeParentModal={close}
        successText={'Şablon uğurla yadda saxlanıldı!'}
        path={pathUrl}
        templates={true}
      />
    </>
  );
};

export default SaveTemplate;
